import { useCookieConsent } from '@packages/shared';
import { useEffect } from 'react';
import config from '@packages/config';
import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

type KuecheCoProp = {
  journey: string;
};

export const KuecheCo = ({ journey }: KuecheCoProp) => {
  // TODO: getting rid of hardcoded key - in storybook I currently cannot get the config of the selected tenant
  const key =
    config.externalScript?.kuecheCo?.key ||
    'pAYrueynYRcqna7lGLoVT39kF83Wy3PYENp81Yw0QJqeTyzAjXvc1FwGOzCm';

  const isAllowed: boolean = useCookieConsent('C0004');
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (isAllowed) {
      dispatchGTMEvent({
        event: 'RenderKuecheCo',
      });
    }
  }, [dispatchGTMEvent, isAllowed]);
  return isAllowed ? (
    <div
      data-testid={ExternalScriptTestIds.KuecheCoScript}
      id="conversional-journey"
      data-api="https://conversional.de/api/"
      data-journey={journey}
      data-version="3"
      data-key={key}
    />
  ) : (
    <div data-testid={ExternalScriptTestIds.KuecheCoScriptNotAllowed} />
  );
};
